import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApplicationContainer from './Desktop/ApplicationContainer';
import Taskbar from './Desktop/Taskbar';
import StartMenu from './Desktop/StartMenu';


const Desktop = ({ isLaunched, setIsLaunched }) => {
    const [startMenuOpen, setStartMenuOpen] = useState(false);
    const [isPortfolioOpen, setIsPortfolioOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const [isContactOpen, setIsContactOpen] = useState(false);
    const [isGalleryOpen, setIsGalleryOpen] = useState(false);
    const [isNewsOpen, setIsNewsOpen] = useState(false);
    const [isRecycleOpen, setIsRecycleOpen] = useState(false);
    const [zFILO, setZFILO] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const path = location.pathname;

        if (path.startsWith('/about')) {
            setIsAboutOpen(false);
            removeFromZFILO('about');
            setIsAboutOpen(true);
            addToZFILO('about');
        } else if (path.startsWith('/portfolio')) {
            setIsPortfolioOpen(false);
            removeFromZFILO('portfolio');
            setIsPortfolioOpen(true);
            addToZFILO('portfolio');
        } else if (path.startsWith('/gallery')) {
            setIsGalleryOpen(false);
            removeFromZFILO('gallery');
            setIsGalleryOpen(true);
            addToZFILO('gallery');
        } else if (path.startsWith('/news')) {
            setIsNewsOpen(false);
            removeFromZFILO('news');
            setIsNewsOpen(true);
            addToZFILO('news');
        } else if (path.startsWith('/contact')) {
            setIsContactOpen(false);
            removeFromZFILO('contact');
            setIsContactOpen(true);
            addToZFILO('contact');
        } else if (path.startsWith('/recycle')) {
            setIsRecycleOpen(false);
            removeFromZFILO('recycle');
            setIsRecycleOpen(true);
            addToZFILO('recycle');
        }

        if (location.pathname === '/') {
            setIsAboutOpen(false);
            removeFromZFILO('about');

            setIsPortfolioOpen(false);
            removeFromZFILO('portfolio');

            setIsNewsOpen(false);
            removeFromZFILO('news');

            setIsGalleryOpen(false);
            removeFromZFILO('gallery');

            setIsContactOpen(false);
            removeFromZFILO('contact');

            setIsRecycleOpen(false);
            removeFromZFILO('recycle');
        }
    }, [location.pathname]);

    const addToZFILO = (windowName) => {
        setZFILO((previousStack) => {
            // Always remove the name first, then add it to the end
            const withoutWindow = previousStack.filter(name => name !== windowName);
            const updatedStack = [...withoutWindow, windowName];
            return updatedStack;
        });
    };

    const removeFromZFILO = (windowName) => {
        setZFILO((previousStack) => {
            const updatedStack = previousStack.filter(name => name !== windowName);
            return updatedStack;
        });
    };

    return (
        <div className='Desktop full-height'>
            <ApplicationContainer
                isAboutOpen={isAboutOpen} setIsAboutOpen={setIsAboutOpen}
                isPortfolioOpen={isPortfolioOpen} setIsPortfolioOpen={setIsPortfolioOpen}
                isContactOpen={isContactOpen} setIsContactOpen={setIsContactOpen}
                isGalleryOpen={isGalleryOpen} setIsGalleryOpen={setIsGalleryOpen}
                isNewsOpen={isNewsOpen} setIsNewsOpen={setIsNewsOpen}
                isRecycleOpen={isRecycleOpen} setIsRecycleOpen={setIsRecycleOpen}
                startMenuOpen={startMenuOpen} setStartMenuOpen={setStartMenuOpen}
                zFILO={zFILO} addToZFILO={addToZFILO} removeFromZFILO={removeFromZFILO}
            />

            <Taskbar
                startMenuOpen={startMenuOpen}
                setStartMenuOpen={setStartMenuOpen}
            />

            {startMenuOpen && <StartMenu
                isAboutOpen={isAboutOpen} setIsAboutOpen={setIsAboutOpen}
                isPortfolioOpen={isPortfolioOpen} setIsPortfolioOpen={setIsPortfolioOpen}
                isContactOpen={isContactOpen} setIsContactOpen={setIsContactOpen}
                isGalleryOpen={isGalleryOpen} setIsGalleryOpen={setIsGalleryOpen}
                isNewsOpen={isNewsOpen} setIsNewsOpen={setIsNewsOpen}
                isRecycleOpen={isRecycleOpen} setIsRecycleOpen={setIsRecycleOpen}
                startMenuOpen={startMenuOpen} setStartMenuOpen={setStartMenuOpen}
                zFILO={zFILO} addToZFILO={addToZFILO} removeFromZFILO={removeFromZFILO}
            />}
        </div>
    );
};


export default Desktop;
